"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createCardComponent = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _context = require("../context");

var _layout = require("../layout");

var _utils = require("../utils");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var createCardComponent = function createCardComponent(_ref) {
  var name = _ref.name,
      tag = _ref.tag,
      interactive = _ref.interactive,
      additionalStyles = _ref.additionalStyles;
  // The styled component has to be casted to any for the style string
  // to work, since it cannot infer the generic type T if it's used as
  // the type on withComponent
  var CardComponent = (0, _context.styledWithTheme)(_layout.View.withComponent(tag, {
    target: "e1l7vlym0"
  }))(_templateObject(), function (_ref2) {
    var theme = _ref2.theme;
    var shadowColor = (0, _utils.opacify)(theme.selectors.color('neutral90'), 0.3);
    var focusColor = theme.selectors.color('primary70');
    var borderColor = theme.selectors.color('neutral50');
    var baseStyle = "\n        box-shadow: 0 0 10px 0 ".concat(shadowColor, ";\n        box-sizing: border-box;\n        transition: transform 0.2s;\n      ");
    var interactiveStyle = "\n        border: 1px solid ".concat(borderColor, ";\n\n        :hover {\n          cursor: pointer;\n          transform: scale(1.08);\n          box-shadow: 0 0 20px 0 ").concat(shadowColor, ";\n        }\n        \n        :focus {\n          outline: 2px solid ").concat(focusColor, ";\n          outline-offset: -2px;\n        }\n      ");
    return "\n        ".concat(baseStyle, "\n        ").concat(interactive ? interactiveStyle : '', "\n        ").concat(!!additionalStyles ? additionalStyles : '', "\n      ");
  }); // Force typescript to recognise the props of the component after
  // erasing them above with `any`

  var TypedCardComponent = CardComponent;
  var CardComponentWithTestAttributes = (0, _utils.withTestAttributes)({
    component: "StencilReact".concat(name)
  })(TypedCardComponent);
  CardComponentWithTestAttributes.displayName = name;
  CardComponentWithTestAttributes.defaultProps = (0, _objectSpread2.default)({}, _layout.View.defaultProps, {
    display: 'flex',
    backgroundColor: 'neutral0',
    padding: 16
  });
  var CardComponentWithDocs = (0, _stencilReactDesc.describe)(CardComponentWithTestAttributes).description("Card component using <".concat(tag, "> element."));
  CardComponentWithDocs.propTypes = (0, _objectSpread2.default)({}, _layout.View.describedPropTypes, {
    children: _stencilReactDesc.PropTypes.node.description('Content to display in the card.')
  });

  CardComponentWithDocs.withComponent = function (newTag) {
    return createCardComponent({
      name: name,
      tag: newTag,
      interactive: interactive,
      additionalStyles: additionalStyles
    });
  };

  return CardComponentWithDocs;
};

exports.createCardComponent = createCardComponent;